import styled from "styled-components";
import Text from "components/Text";

export const Container = styled.div`
  width: 420px;

  @media screen and (max-width: 665px) {
    width: 100%;
  }
`;

type MessageContentType = {
  backgroundColor: string;
  borderColor: string;
}

type TextItemType = {
  sizeText: number;
  colorText: string;
}

export const MessageContent = styled.div<MessageContentType>`  
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  height: 100%;

  padding: 4px 8px;
  border-radius: 4px;

  border: 1px solid ${props => props.borderColor };
  background-color: ${(props) => props.backgroundColor};

  .text-item {
    color: #E02828
  }

  svg {
    min-width: 16px;
  }
`
export const TextItem = styled(Text).attrs<TextItemType>(({colorText, sizeText}) => ({
  size: sizeText,
  color: colorText
}))<TextItemType>`
  font-weight: 400;
  font-size: 14px !important;
  white-space: break-spaces;
`;